import { AHButton, AHEmptyScreen } from "arkh";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Lottie } from "../../components/Lottie";

export function FilesEmptyComponent(props: {
  canAdminFiles: boolean;
  onRequestUpload: () => void;
}) {
  return (
    <AHEmptyScreen
      title={
        <FormattedMessage
          description="File Empty Screen Title"
          defaultMessage="Add files!"
        />
      }
      subtitle={
        <FormattedMessage
          description="File Empty Screen Subtitle"
          defaultMessage="Upload your files from a mobile device or access StoreSprint.app from the computer!"
        />
      }
      illustration={
        <Lottie
          autoPlay
          loop
          source={require("../../assets/shake-a-empty-box.json")}
        />
      }
      cta={
        props.canAdminFiles ? (
          <AHButton
            iconRight
            iconType="files"
            onPress={props.onRequestUpload}
            themeType="primary"
            title={
              <FormattedMessage
                description="File Empty Screen Upload Files CTA"
                defaultMessage="Add files"
              />
            }
          />
        ) : null
      }
    />
  );
}
